import { Route, Routes } from "react-router-dom";

import {TeamSecurityLink } from "../../pages";

export const TeamSecurityLinkLayout = () =>{
  return (
    <Routes>
    <Route path="/" element={<TeamSecurityLink/>} />
  </Routes>
  )
}

    
  
